export default __webpack_public_path__ + "static/media/Location Tracking Module.092886d8.png";